import { Component } from "@angular/core";

@Component({
  selector: 'thead[app-dt-head]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['dt-head.component.scss'],
})
export class DtHeadComponent {}
